import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import GiveawayPage from "../pages/giveaway/page";
import PrivacyPolicyPage from "../pages/privacy-policy/page";
import TermsOfServicePage from "../pages/terms-of-service/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/giveaway",
    element: <GiveawayPage />,
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPolicyPage />,
  },
  {
    path: "/terms-of-service",
    element: <TermsOfServicePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
